import React, { useEffect, useState } from 'react'
import { TableManipulationTopContainer } from 'core-system/Table'
import { styled } from '@mui/material/styles'
import Text from 'core-system/Text'
import Dropdown from 'core-system/Dropdown'
import reportTypes from './reportTypes.json'
import Grid from '@mui/material/Grid2'
import MonthRangePicker from 'core-system/MonthRangePicker'
import { YearMonth } from 'core-system/MonthRangePicker/DropdownCalendar'
import WorksiteGroupDropdown from 'features/Programs/Launch/Components/WorksiteGroupDropdown'
import { useSelector } from 'react-redux'
import { AppState } from 'redux/config/store'
import { arrangeAllSegmentsForSelection } from 'features/Programs/Shared/helperFunctions'
import { SegmentListType } from 'features/Programs/Shared/types'
import { ReportType } from '../types'
const HorizontalContainer = styled(Grid)`
  width: 100%;
`

const HorizontalItem = styled(Grid)`
  display: flex;
  flex-direction: column;
`

const TitleText = styled(Text)`
  font-weight: 300;
`

const Title = ({ title }: { title: string }) => (
  <TitleText variant='action2' marginBottom='0.75rem'>
    {title}
  </TitleText>
)

interface ReportingFiltersProps {
  selectedReportType: ReportType
  selectedStartDate: YearMonth
  selectedEndDate: YearMonth
  selectedSegments: SegmentListType[]
  changeReportType: (reportType: ReportType) => void
  changeStartDate: (startDate: YearMonth) => void
  changeEndDate: (endDate: YearMonth) => void
  changeSegments: (segments: SegmentListType[]) => void
  isTableLoading: boolean
}

const ReportingFilters = ({
  selectedReportType,
  selectedStartDate,
  selectedEndDate,
  selectedSegments = [],
  changeReportType = () => {},
  changeStartDate = () => {},
  changeEndDate = () => {},
  changeSegments = () => {},
  isTableLoading = false,
}: ReportingFiltersProps) => {
  const [selectedMonthsError, setSelectedMonthsError] = useState(false)

  useEffect(() => {
    changeSegments([])
    changeStartDate(null)
    changeEndDate(null)
  }, [selectedReportType])

  const { allSegments } = useSelector((state: AppState) => state.employer)
  return (
    <TableManipulationTopContainer>
      <HorizontalContainer container spacing={3}>
        <HorizontalItem size={{ xs: 12, sm: 12, md: 4 }}>
          <Title title='Report Type' />
          <Dropdown
            items={reportTypes}
            active={selectedReportType}
            itemCallback={({ id }) => changeReportType(id as ReportType)}
            width='100%'
            disabled={isTableLoading}
          />
        </HorizontalItem>
        <HorizontalItem size={{ xs: 12, sm: 12, md: 4 }}>
          <Title title='Time Period' />
          <MonthRangePicker
            error={selectedMonthsError}
            errorMessage='Select a Valid Date Range'
            errorSetter={setSelectedMonthsError}
            placeholder='--'
            selectedStartDate={selectedStartDate}
            startDateSetter={changeStartDate}
            selectedEndDate={selectedEndDate}
            endDateSetter={changeEndDate}
            disabled={isTableLoading}
          />
        </HorizontalItem>
        <HorizontalItem size={{ xs: 12, sm: 12, md: 4 }}>
          <Title title='Group' />
          <WorksiteGroupDropdown
            items={arrangeAllSegmentsForSelection(allSegments)}
            activeItems={selectedSegments}
            onItemCallback={changeSegments}
            width='100%'
            showAllSelectedItems={false}
            disabled={isTableLoading}
            isCustomGroupDisabled={selectedReportType === 'programAllocation'}
          />
        </HorizontalItem>
      </HorizontalContainer>
    </TableManipulationTopContainer>
  )
}

export default ReportingFilters
